module.exports = __webpack_public_path__ + "img/product_101.56846ba.webp";